import {
  Alert,
  Box,
  Grid,
  IconButton,
  Stack,
  StackProps,
  styled,
  Typography,
} from '@mui/material';

/**
 * TODO: Remove this and use props instead e.g.
 * <Stack
 *  direction="row"
 *  justifyContent="center"
 *  alignItems="center"
 *  spacing={1}
 * >
 * */
export const CardContainer = styled((props: StackProps) => (
  <Stack direction="row" spacing={1} {...props} />
))`
  align-items: center;
`;

export const CardContainerBox = styled(Box)`
  height: 100%;
`;

export const CardInfoTitle = styled(Typography)`
  flex: 1;
  font-weight: 500;
  width: 250px;
`;

export const CardMenuIcon = styled(IconButton)(
  ({ theme, $hasVisible }) => `
    z-index: 1200;
    visibility: ${$hasVisible ? 'visible' : 'hidden'};
    transition: all 0.3s ease;
    position: absolute;
    top: 8px;
    right: 5px;
    border-radius: 4px;
    background-color: ${theme.palette.primary.contrastText};
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  `,
);
export const CardText = styled(Typography)`
  font-size: 0.875rem;
  font-weight: 300;
`;
export const CardGridContainer = styled(Grid)`
  margin-bottom: 1rem;
  padding: 4px;
`;

export const CardGridItem = styled(Grid)`
  display: flex;
  flex-direction: column;
`;

export const EmptyProductCategory = styled(Grid)`
  margin-top: 1.5rem;
`;

export const ChipContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const InViewContainer = styled(Box)`
  height: 10px;
  width: 100%;
`;

export const StyledAlert = styled(Alert)`
  width: 100%;
  padding: 8px 0px;
  gap: 4px;
  .MuiAlert-icon {
    padding-left: 8px;
  }
`;
export const SelectComponentContainer = styled(Grid)`
  padding: 0.5rem;
  padding-bottom: 10rem;
  align-items: stretch;
`;
